import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature, IUserAccessSubFeatures} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';
import {IUserAccessFeatureLocalStorageSettings} from '../access';

//#region INTERFACE IFeatureLocalStorageManager
export interface IFeatureLocalStorageManager extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_LOCAL_STORAGE_MANAGER_DEFAULT
export const _FEATURE_LOCAL_STORAGE_MANAGER_DEFAULT: Readonly<IFeatureLocalStorageManager & Object> = {
  displayText: NavigationPageEnumHumanReadable.LocalStorageManager,
  feature: NavigationPageEnum.LocalStorageManager,
  ref: SettingsReferenceEnum.featureLocalStorageManager,
  standalone: true,
};
//#endregion

//#region INTERFACE IFeatureLocalStorage
export interface IFeatureLocalStorage extends IUserAccessFeature, Object {
  crudAccess: { [storeId: string]: IUserAccessFeatureLocalStorageSettings };
}

//#endregion

//#region CONST _FEATURE_LOCAL_STORAGE_DEFAULT
export const _FEATURE_LOCAL_STORAGE_DEFAULT: Readonly<IFeatureLocalStorage & Object> = {
  displayText: NavigationPageEnumHumanReadable.LocalStorage,
  feature: NavigationPageEnum.LocalStorage,
  ref: SettingsReferenceEnum.featureLocalStorage,
  standalone: false,
  subFeatures: [
    {..._FEATURE_LOCAL_STORAGE_MANAGER_DEFAULT},
  ],
  crudAccess: {},
};
//#endregion
